<app-navigation-header i18n-title="@@userProfile-myAccountTitle" title="My Account">
	<div class="column edit-toggle-page">
		<div class="content-container">
			<div class="content-container-header flex-row-end">
				<h3 class="flex-grow" i18n="@@userProfile-accountDetails">Account Details</h3>
				@if (this.isEditing === false) {
					<div class="spacing-24 flex-fixed">
						<button
							mat-button
							i18n="@@userProfile-edit"
							class="primary-button"
							(click)="isEditing = true"
							data-automation-id="profile-edit-button"
						>
							Edit
						</button>
					</div>
				}
				@if (this.isEditing) {
					<div class="spacing-8 flex-fixed flex-row">
						<div class="flex-1">
							<button
								mat-button
								i18n="@@userProfile-cancel"
								class="secondary-button"
								(click)="isEditing = false"
								data-automation-id="profile-cancel-button"
							>
								Cancel
							</button>
						</div>
						<div class="flex-1">
							<button
								mat-button
								i18n="@@userProfile-changePassword"
								class="primary-button min-width-button-150pt"
								(click)="changePassword()"
								data-automation-id="profile-change-password-button"
							>
								Change Password
							</button>
						</div>
						<div class="flex-1">
							<button
								mat-button
								i18n="@@userProfile-saveChanges"
								class="primary-button min-width-button-115pt"
								(click)="saveProfile()"
								data-automation-id="profile-save-changes-button"
							>
								Save Changes
							</button>
						</div>
					</div>
				}
			</div>

			<mat-divider></mat-divider>

			<div class="content-container-body column spacing-24">
				@if (!this.isEditing) {
					<div class="row">
						<div class="row top-bottom-padding">
							<table style="width: 100%">
								<tr class="mat-body-2">
									<td class="width-50-grey" i18n="@@userProfile-firstName">First Name</td>
									<td class="width-50-grey" i18n="@@userProfile-lastName">Last Name</td>
								</tr>
								<tr class="mat-body-3">
									<td class="table-body-text">{{ userProfile?.user?.firstName }}</td>
									<td class="table-body-text">{{ userProfile?.user?.lastName }}</td>
								</tr>
							</table>
						</div>
						<div class="row top-bottom-padding">
							<table style="width: 100%">
								<tr class="mat-body-2">
									<td class="width-50-grey" i18n="@@userProfile-emailHeader">Email Address</td>
									<td class="width-50-grey" i18n="@@userProfile-mobileNumber">Mobile Number</td>
								</tr>
								<tr class="mat-body-3">
									<td class="table-body-text">{{ userProfile?.user?.email }}</td>
									<td class="table-body-text">{{ userProfile?.user?.phoneNumber | phoneNumber }}</td>
								</tr>
							</table>
						</div>
					</div>
				} @else {
					<div class="edit-input-fields">
						<div class="field-container">
							<mat-form-field
								subscriptSizing="dynamic"
								class="form-field-width"
								style="margin-right: 12px"
								appearance="outline"
							>
								<mat-label i18n="@@userProfile-firstName">First Name</mat-label>
								<input matInput [formControl]="firstNameFormControl" required data-automation-id="first-name-input" />
								@if (firstNameFormControl.errors?.required) {
									<mat-error i18n="@@userProfile-firstNameReq" data-automation-id="first-name-error"
										>First Name is required</mat-error
									>
								}
								@if (!firstNameFormControl.errors?.required && firstNameFormControl.errors?.pattern) {
									<mat-error i18n="@@userProfile-firstNameInvalidCharacters" data-automation-id="first-name-error"
										>First Name contains invalid characters
									</mat-error>
								}
								@if (
									!firstNameFormControl.errors?.required &&
									!firstNameFormControl.errors?.pattern &&
									firstNameFormControl.errors?.maxlength
								) {
									<mat-error i18n="@@userProfile-firstNameTooLong" data-automation-id="first-name-error">
										First Name cannot contain more than 50 characters
									</mat-error>
								}
							</mat-form-field>
						</div>
						<div class="field-container">
							<mat-form-field
								subscriptSizing="dynamic"
								class="form-field-width"
								style="margin-left: 12px"
								appearance="outline"
							>
								<mat-label i18n="@@userProfile-lastName">Last Name</mat-label>
								<input matInput [formControl]="lastNameFormControl" required data-automation-id="last-name-input" />
								@if (lastNameFormControl.errors?.required) {
									<mat-error i18n="@@userProfile-lastNameReq" data-automation-id="first-name-error"
										>Last Name is required</mat-error
									>
								}
								@if (!lastNameFormControl.errors?.required && lastNameFormControl.errors?.pattern) {
									<mat-error i18n="@@userProfile-lastNameInvalidChar" data-automation-id="last-name-error"
										>Last Name contains invalid characters
									</mat-error>
								}
								@if (
									!lastNameFormControl.errors?.required &&
									!lastNameFormControl.errors?.pattern &&
									lastNameFormControl.errors?.maxlength
								) {
									<mat-error i18n="@@userProfile-lastNameTooLong" data-automation-id="last-name-error">
										Last Name cannot contain more than 50 characters
									</mat-error>
								}
							</mat-form-field>
						</div>
					</div>
					<div class="edit-input-fields">
						<div class="field-container">
							<div class="flex-column">
								<mat-form-field
									subscriptSizing="dynamic"
									class="form-field-width"
									style="margin-right: 12px"
									appearance="outline"
								>
									<mat-label i18n="@@userProfile-email">Email Address</mat-label>
									<input
										matInput
										[disabled]="true"
										[value]="userProfile?.user?.email || ''"
										data-automation-id="email-input"
									/>
								</mat-form-field>
								<a
									[routerLink]="[]"
									(click)="changeEmail()"
									data-automation-id="email-link"
									i18n="@@userProfile-changeEmail"
									>Change Email</a
								>
							</div>
						</div>
						<div class="field-container">
							<div class="flex-column" style="margin-left: 12px">
								<mat-form-field subscriptSizing="dynamic" class="form-field-width" appearance="outline">
									<mat-label i18n="@@userProfile-mobileNumber">Mobile Number</mat-label>
									<input
										matInput
										[disabled]="true"
										[value]="(userProfile?.user?.phoneNumber | phoneNumber) || ''"
										data-automation-id="mobile-number-input"
									/>
								</mat-form-field>
								<a
									[routerLink]="[]"
									(click)="changeMobileNumber()"
									data-automation-id="mobile-number-link"
									i18n="@@userProfile-changeMobileNumber"
									>Change Mobile Number</a
								>
							</div>
						</div>
					</div>
				}
			</div>

			<!--   Edit Mode  -->
		</div>
	</div>

	<app-notification-preferences></app-notification-preferences>
</app-navigation-header>
